import SvgIcon from "../../../designSystem/SvgIcon";
import { ReactComponent as AIPremium } from "../../../assets/icons/AI Premium.svg";
import { ReactComponent as Camera } from "../../../assets/icons/Camera 3 1.svg";
import { ReactComponent as Dart } from "../../../assets/icons/Dart 1.svg";
import { ReactComponent as Globe } from "../../../assets/icons/Globe 8.svg";
import { ReactComponent as Key } from "../../../assets/icons/Key 1.svg";
import { ReactComponent as LineChart } from "../../../assets/icons/Line chart 1.svg";
import { ReactComponent as PenTool } from "../../../assets/icons/Pen tool 1.svg";
import { ReactComponent as PhoneHeart } from "../../../assets/icons/Phone heart 1.svg";
import { ReactComponent as SpaceShip } from "../../../assets/icons/Spaceship 1.svg";
import { ReactComponent as TimeAlarm } from "../../../assets/icons/Time alarm 1.svg";
import { ReactComponent as VoiceRecord } from "../../../assets/icons/Voice record 1.svg";
import { ReactComponent as Crown } from "../../../assets/icons/crown.svg";
import { ReactComponent as Share } from "../../../assets/icons/mdi_share.svg";
import { ReactComponent as AddTag } from "../../../assets/icons/mdi_tag-add.svg";
import { ReactComponent as MultipleDelete } from "../../../assets/icons/multiple delete.svg";
import { ReactComponent as BusinessToPost } from "../../../assets/solar_icons/Case.svg";
import { ReactComponent as QuoteToPost } from "../../../assets/solar_icons/Chat  Square Call.svg";
import { ReactComponent as Listicles } from "../../../assets/solar_icons/Clipboard List.svg";
import { ReactComponent as TextToPost } from "../../../assets/solar_icons/Document Add.svg";
import { ReactComponent as ScriptToPost } from "../../../assets/solar_icons/Document Text.svg";
import { ReactComponent as EcomAds } from "../../../assets/solar_icons/MagicStick2normal.svg";
import { ReactComponent as AdCreatives } from "../../../assets/solar_icons/DocumentTextNormal.svg";
import { ReactComponent as BlogToPost } from "../../../assets/solar_icons/Documents.svg";
import { ReactComponent as EccomerceToPost } from "../../../assets/solar_icons/Shop.svg";
import { ReactComponent as Template } from "../../../assets/solar_icons_gradient/Notes.svg";
import { ReactComponent as Create } from "../../../assets/icons/CreateIcon.svg";
import { ReactComponent as ColorPicker } from "../../../assets/icons/colorPicker.svg";
import { ReactComponent as Logout } from "../../../assets/icons/sign-out.svg";
import { ReactComponent as ArrowDownBorder } from "../../../assets/icons/angle.svg";
import { ReactComponent as EcommerceAdsToPost } from "../../../assets/solar_icons/MagicStick2.svg";
import { ReactComponent as LanguageSelection } from "../../../assets/icons/mdi_language.svg";
import { ReactComponent as TextAlignCenter } from "../../../assets/solar_icons/text_align_center.svg";
import { ReactComponent as TextAlignJustify } from "../../../assets/solar_icons/text_justify.svg";
import { ReactComponent as TextAlignLeft } from "../../../assets/solar_icons/text_align_left.svg";
import { ReactComponent as TextAlignRight } from "../../../assets/solar_icons/text_align_right.svg";
import { ReactComponent as Proofread } from "../../../assets/solar_icons/proofread_icon.svg";
import { ReactComponent as SVGSquare } from "../../../assets/solar_icons/SVGIcon.svg";
import { ReactComponent as CanadaFlag } from "../../../assets/flag_icons/canada-flag-icon.svg";
import { ReactComponent as AustraliaFlag } from "../../../assets/flag_icons/australia-flag-icon.svg";
import { ReactComponent as IndiaFlag } from "../../../assets/flag_icons/INDIA.svg";
import { ReactComponent as BrazilFlag } from "../../../assets/flag_icons/BRAZIL.svg";
import { ReactComponent as UAEFlag } from "../../../assets/flag_icons/UAE.svg";
import { ReactComponent as SingaporeFlag } from "../../../assets/flag_icons/Singapore.svg";
import { ReactComponent as Star } from "../../../assets/solar_icons/Star.svg";

export const RocketIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={SpaceShip} />
  );
};
export const LineChartIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={LineChart} />
  );
};
export const VoiceRecordIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={VoiceRecord} />
  );
};
export const PenToolIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={PenTool} />
  );
};
export const GlobeIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={Globe} />
  );
};
export const DartIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={Dart} />
  );
};
export const PhoneHeartIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={PhoneHeart} />
  );
};
export const CameraIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={Camera} />
  );
};
export const TimeAlarmIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={TimeAlarm} />
  );
};
export const KeyIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={Key} />
  );
};
export const CrownIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={Crown} />
  );
};
export const AIPremiumIcon = (props) => {
  return (
    // <SpaceShip width={40} height={40} />
    <SvgIcon inheritViewBox {...props} component={AIPremium} />
  );
};
// export const PostDownloadIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PostDownload} />;
// };
// export const NextPostIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={NextPost} />;
// };
// export const PrevPostIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PrevPost} />;
// };
// export const PostArchiveIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PostArchive} />;
// };
// export const PostDuplicateIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PostDuplicate} />;
// };
// export const AddTagIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={AddTag} />;
// };
export const ShareIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Share} />;
};
export const AddTagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={AddTag} />;
};
export const MultipleDeleteIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={MultipleDelete} />;
};

export const TextToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={TextToPost} />;
};

export const BusinessToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={BusinessToPost} />;
};

export const ScriptToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={ScriptToPost} />;
};

export const AdCreativesIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={AdCreatives} />;
};

export const EcomAdsIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={EcomAds} />;
};

export const EcommerceAdsToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={EcommerceAdsToPost} />;
};

export const BlogToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={BlogToPost} />;
};

export const QuoteToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={QuoteToPost} />;
};

export const EccomerceToPostIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={EccomerceToPost} />;
};

export const ChooseTemplateIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Template} />;
};

export const ListiclesIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Listicles} />;
};

export const CreateIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Create} />;
};

export const ColorPickerIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={ColorPicker} />;
};

export const LogoutIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Logout} />;
};

export const ArrowDownBorderIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={ArrowDownBorder} />;
};

export const LanguageSelectionIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={LanguageSelection} />;
};

export const TextAlignCenterIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={TextAlignCenter} />;
};
export const TextAlignJustifyIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={TextAlignJustify} />;
};
export const TextAlignLeftIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={TextAlignLeft} />;
};
export const TextAlignRightIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={TextAlignRight} />;
};
export const ProofreadIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Proofread} />;
};
export const SVGSquareIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={SVGSquare} />;
};
export const CanadaFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={CanadaFlag} />;
};
export const AustraliaFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={AustraliaFlag} />;
};
export const IndiaFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={IndiaFlag} />;
};
export const BrazilFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={BrazilFlag} />;
};
export const UAEFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={UAEFlag} />;
};
export const SingaporeFlagIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={SingaporeFlag} />;
};
export const StarIcon = (props) => {
  return <SvgIcon inheritViewBox {...props} component={Star} />;
};
// export const SaveAsTemplateIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={SaveAsTemplate} />;
// };
// export const PostFavoriteIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PostFavorite} />;
// };
// export const PostDeleteIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={PostDelete} />;
// };
// export const EditPostIcon = (props) => {
//   return <SvgIcon inheritViewBox {...props} component={EditPost} />;
// };
